<ng-container *ngIf="!isHeadless">
  <app-breadcrumb [title]="'Преглед на сигнали'"
                  [items]="['Сигнали']"
                  [active_item]="'Списък сигнали'">
  </app-breadcrumb>
</ng-container>
<ng-container *ngIf="!isLoading; else loadingTemplate">
  <div class="card card-reset">

    <!-- Card header -->
    <div class="card-header">
      <div  class="row">
        <div class="col">
          <div class="d-flex flex-row justify-content-between">
            <div>
              <app-toggle-btn [objects]="viewToggleOptions"
                              [bindProperty]="'value'"
                              [currentlySelectedObject]="currentlySelectedView"
                              (clicked)="onViewChange($event)"></app-toggle-btn>
            </div>
            <div class="d-flex flex-row gap-3">
              <button
                      type="button"
                      class="btn btn-warning btn-sm"
                      (click)="onRefresh()">
                <i class="fa fa-refresh"></i>
              </button>

              <button *ngIf="isUserDispatcher"
                      type="button"
                      class="btn btn-success btn-sm"
                      (click)="onAddNewSignalClicked()">
                <i class="fa fa-plus"></i> Регистрирай Сигнал
              </button>
              <button type="button"
                      class="btn btn-light btn-sm"
                      (click)="toggleSearchFilters()">
                <i class="fa fa-filter"></i> {{searchFiltersToggled ? 'Скрий филтрите': 'Покажи филтрите'}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="searchFiltersToggled " class="row mt-3">
        <div class="col">
          <app-signal-filter-form [signalStatusesList]="signalStatusesList"
                                  [initialFilter]="signalsSearchFilter"
                                  (filterClicked)="onFilterSignalsList($event)">
          </app-signal-filter-form>
        </div>
      </div>
    </div>

    <!-- Card body -->
    <div class="card-body">
      <ng-container *ngIf="!!signalsSearchFilter">
        <ng-container *ngTemplateOutlet="filtersResultInfo"></ng-container>
      </ng-container>

      <ng-container *ngIf="isGridView">
        <table class="table table-sm table-reset table-hover">
          <thead>
            <tr>
              <th scope="col">Идентификатор</th>
              <th scope="col">Заглавие</th>
              <th scope="col">Дата на подаване</th>
              <th scope="col">Статус на сигнала</th>
              <th *ngIf="!isDashboardView" scope="col" class="icon-col"></th>
              <th scope="col">Тип авария</th>
              <th scope="col">Описание</th>
              <th scope="col">Диспечер</th>
              <th  *ngIf="!isDashboardView" scope="col">Зачислен от</th>
              <th  *ngIf="!isDashboardView" scope="col">Зачислен на</th>
              <th scope="col" class="map-view-action-col">Място</th>
              <th scope="col" class="signal-check-action-col">Избор на действие</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let rs of filteredRegisteredSignalsList">
              <tr [ngClass]="!isGridRowSelected(rs)? '':'selected-row'" (click)="onGridRowSelected(rs)">
                <td>{{rs.id}}</td>
                <td class="incident-title">{{rs.title}}</td>
                <td>{{rs.when | date}}</td>
                <td><b>{{rs.signalStatus.title}}</b></td>
                <td  *ngIf="!isDashboardView" class="icon-col">
                  <i *ngIf="rs.checkoutAdittionalInfo"
                     class="fa fa-info-circle"
                     ngbTooltip="{{rs.checkoutWhen}}: {{rs.checkoutAdittionalInfo}}"
                     placement="top">
                  </i>
                </td>
                <td>{{rs.tipAvaria.title}}</td>
                <td>{{rs.description}}</td>
                <td>{{getDispecherNames(rs)}}</td>
                <td  *ngIf="!isDashboardView">{{getSignalRequestorNames(rs)}}</td>
                <td  *ngIf="!isDashboardView">{{getZachislenSignal(rs)}}</td>
                <td class="map-view-action-col">
                  <button class="grid-btn btn-light btn btn-sm"
                          ngbTooltip="Натиснете тук за да визуализирате местоположението на сигнала в/у картата."
                          placement="top"
                          (click)="onToggleMapView(rs)">
                    {{isLocationMapView(rs) ? 'Скрий' : 'Покажи'}}
                  </button>
                </td>

                <td class="signal-check-action-col">
                  <div class="buttons-wrapper" style="display:flex;" >
                    <button class="grid-btn btn btn-info btn-sm"
                            ngbTooltip="Натиснете тук за да прегледате сигнала."
                            placement="top"
                            (click)="openReadOnlySignalViewModal(rs)">
                      <i class="fa fa-eye"></i>
                    </button>

                    <button *ngIf="isEditingAllowed(rs) && !isSignalProcessBtnVisible(rs)"
                            class="grid-btn btn btn-warning btn-sm"
                            ngbTooltip="Натиснете тук за да редактирате сигнала."
                            placement="top"
                            [disabled]="!isEditingAllowed(rs)"
                            (click)="onSignalEditClicked(rs)">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button *ngIf="isSignalProcessBtnVisible(rs)"
                            class="grid-btn btn btn-primary btn-sm"
                            ngbTooltip="Натиснете тук за да започнете обработката на сигнала."
                            placement="top"
                            (click)="onSignalProcessClicked(rs)">
                      <i class="fa fa-cog"></i>
                    </button>

                    <button *ngIf="isSignalCheckUpBtnVisible(rs)"
                            class="grid-btn btn btn-primary btn-sm"
                            ngbTooltip="Натиснете тук за да организирате проверка"
                            placement="top"
                            (click)="onSignalCheckProceedClicked(rs)">
                      <i class="fa fa-map-marker"></i>
                    </button>

                    <button *ngIf="isSignalFinalizeBtnVisible(rs)"
                            class="grid-btn btn btn-primary btn-sm"
                            ngbTooltip="Натиснете тук за да финализирате сигнала като авария или фалшива тревога."
                            placement="top"
                            (click)="onSignalFinalizeClicked(rs)">
                      <i class="fa fa-check"></i>
                    </button>
                    <button *ngIf="isEditingAllowed(rs) && !isSignalProcessBtnVisible(rs)"
                            class="grid-btn btn btn-danger btn-sm"
                            ngbTooltip="Натиснете тук за да изтриете сигнала."
                            placement="top"
                            [disabled]="!isEditingAllowed(rs)"
                            (click)="onSignalDeletion(rs)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="isLocationMapView(rs)" class="expandable-colspan-row">
                <td class="col-xs-12" [attr.colspan]="gridColsNum">
                  <app-map-location-selector [location]="{lat: +rs.latitude, lng: +rs.longitude}"
                                             [readonly]="true"
                                             [focusView]="false"
                                             [zoom]="16">
                  </app-map-location-selector>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </ng-container>

      <ng-container *ngIf="isMapView">
        <app-signals-map-view [signalsList]="filteredRegisteredSignalsList"
                              [focusView]="true">
        </app-signals-map-view>
      </ng-container>

    </div>
  </div>
</ng-container>


<ng-template #loadingTemplate>
  <app-loader text="Зареждане на списъка със сигнали..."></app-loader>
</ng-template>

<!--Applied filters Info-->
<ng-template #filtersResultInfo>
  <div role="alert" class="alert alert-info outline d-flex flex-row justify-content-between">
    <p>
      <i class="fa fa-filter"></i> <span>Показани са <span class="fw-bold">само</span> тези резултитати, които отговарят на <span class="fw-bold">избраните филтри</span>.</span>
    </p>
    <button type="submit" name="signalListFilterclearBtn" class="btn btn-info btn-sm" (click)="onClearFiltersClicked()">
      Изчисти филтрите
    </button>
  </div>
</ng-template>
